import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Document } from '../../../../../interfaces/Document';
import { StyledLink, StyledDiv, StyledT4, StyledP, StyledContainer } from '../DocumentListGroup.styles';
import { StyledDocumentIcon, StyledDownloadIconWrapper } from './DocumentListItem.styles';
import getPublicApiRoot from '../../../../../utils/getPublicApiRoot';
export interface DocumentListItemProps {
  document: Document;
}

const DocumentListItem: FC<DocumentListItemProps> = ({ document, ...props }) => {
  const { t } = useTranslation('Documents');
  const documentPath = `${getPublicApiRoot()}/content/secure?fileToken=${document.fileToken}`;
  if (!document.visible) return null;

  return (
    <StyledContainer>
      <StyledLink
        unread={!document.read}
        href={documentPath}
        target="_blank"
        aria-label={t('download')}
        {...props}
      >
        <StyledDiv>
          <StyledT4 isRead={document.read}>{document.name}</StyledT4>
          <StyledP>{document.contract.contractName} - {document.contract.contractNumber}</StyledP>
        </StyledDiv>
        <StyledDownloadIconWrapper>
          <StyledDocumentIcon />
        </StyledDownloadIconWrapper>
      </StyledLink>
    </StyledContainer>
  );
};

export default DocumentListItem;
